import { defineMessages } from 'react-intl';

export default defineMessages({
  livestreamStartsIn: {
    id: 'CourseLivestream.livestreamStartsIn',
    defaultMessage:
      'Livestream starts in <br /><div>{days} {hours}:{minutes}:{seconds}</div>',
  },
  days: {
    id: 'CourseLivestream.days',
    defaultMessage: '{days} {days, plural, one {day} other {days}}',
  },
  livestreamChat: {
    id: 'CourseLivestream.livestreamChat',
    defaultMessage: 'Livestream chat',
  },
});
